module.exports = __webpack_public_path__ + "static/assets/1fb625f77785de8fad61120e886b2b66.png";